export default "__VITE_ASSET__m54bDK$a__"